import { render } from "./PlanCambaceo.vue?vue&type=template&id=074f9920&scoped=true&lang=pug"
import script from "./PlanCambaceo.vue?vue&type=script&lang=js"
export * from "./PlanCambaceo.vue?vue&type=script&lang=js"

import "./PlanCambaceo.vue?vue&type=style&index=0&id=074f9920&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074f9920"]])

export default __exports__